import CompositeImage from './CompositeImage.view';

export default CompositeImage;
